import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Leaderboard from './views/Leaderboard';
import Login from './views/Login';
import { Auth } from './firebase/auth';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      component: Leaderboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/profile',
      name: 'profile',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Profile.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const { currentUser } = Auth;
  console.log(currentUser);
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next('login');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});
export default router;
